module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d5daff71b359c33eb3d8a6647567d53a.png";